<template>
  <Modal>
    <Modal.Title>Copyright owners</Modal.Title>
    <Modal.Body>
      <p class="mb-4">
        Select from this list of copyright owners and organizations to attribute
        ownership when you add your work to Dacr.
      </p>

      <div
        class="-mx-6 mb-4 max-h-[280px] divide-y divide-gray-800/8 overflow-y-auto border-y border-gray-800/8 px-6"
        @scroll="handleScroll"
      >
        <CopyrightOwnerRow
          v-for="owner in owners"
          :key="owner.id"
          :owner="owner"
          :account="isAccount(owner)"
          :managed-by="isOrganization(owner) ? managedBy(owner) : ''"
          @edit="handleEdit(owner)"
          @remove="handleDelete(owner)"
        />
      </div>

      <button
        type="button"
        class="flex w-fit items-center gap-2.5 font-medium text-green-700"
        @click="handleNew"
      >
        <span
          class="flex size-6 items-center justify-center rounded-full bg-green-700/10"
        >
          <AddIcon class="size-4" />
        </span>
        Add new copyright owner
      </button>
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'
import { AddIcon } from '@dacr/icons'
import CopyrightOwnerRow from './CopyrightOwnerRow.vue'
import { useCopyrightOwners } from './useCopyrightOwners'

const {
  owners,
  isAccount,
  isOrganization,
  managedBy,
  handleScroll,
  handleNew,
  handleEdit,
  handleDelete,
} = useCopyrightOwners()
</script>
